import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { CertificatesService } from '@app/core/services/certificates.service'
import { AlertService } from "@app/core/services";

@Component({
    selector: 'modal-upload-certificate-ue',
    templateUrl: 'modal-upload-certificate-ue.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalUploadCertificateUE {
    @Input() evaluationId = null

    submitted = false

    // To upload certificate UE
    uploading = false
    fileCertificate = null
    certificate_comments = ''

    constructor(
        public modal: NgbActiveModal,
        private alertService: AlertService,
        private certificatesService: CertificatesService,
    ) {}

    loadCertificateFile(event) {
        this.fileCertificate = event.target.files[0];
    }

    removeUploadingFile(fileInput: HTMLInputElement) {
        fileInput.value = '' // Clear input file
        this.fileCertificate = null
    }

    uploadCertificate() {
        this.submitted = true

        if(this.fileCertificate === null) return

        this.uploading = true

        const formData = new FormData()
        formData.append('file', this.fileCertificate)
        formData.append('json_data', JSON.stringify({comments: this.certificate_comments}))

        this.certificatesService.updateCertificateUE(this.evaluationId, formData)
            .subscribe(
                response => {
                    this.modal.close(true)
                    this.modal.dismiss()
                },
                error => {
                    this.uploading = false
                    this.alertService.error("Error al subir certificado", { autoClose: true })
                }
            )
    }
}